var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('sj-button',{staticStyle:{"margin":"10px"},on:{"click":_vm.click1}},[_vm._v("基础上传")]),_c('sj-button',{staticStyle:{"margin":"10px"},on:{"click":_vm.click2}},[_vm._v("只允许图片")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }